import { render, staticRenderFns } from "./NursePresenceWidget.vue?vue&type=template&id=5be36fd1&"
import script from "./NursePresenceWidget.vue?vue&type=script&lang=js&"
export * from "./NursePresenceWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports